module.exports = __webpack_public_path__ + "static/media/real6.1f9406c8.jpg";